<div class="d-flex align-items-center justify-content-center">
  @if (loading) {
    <div class="loading" [hidden]="errorMessage"></div>
  }
</div>
<!-- <div class="pb-2" >
<div class="wre-error"> </div>
</div> -->
@if (errorMessage) {
  <div class="alert alert-danger" role="alert">
    {{ errorMessageInfo }}
  </div>
}
